import type { RelationTreeType } from '@/asset/AssetTask/templates/Cascade/type';
import { Api as FetchAPI } from '@/utils';
import { ruleMapMatchExec, getValuesByRow } from '@/store/rulesCalc';
import useMetaStore from '@/store/useMetaStore';

interface GetSPTableWithModelSchemaProps {
  schemaList: RelationTreeType[] | never[];
  metaConfig: any;
  values: any;
  rulesMap: any;
}

// 获取recordListModule对应schema
export const useSPTableWithModelSchema = ({
  schemaList = [],
  metaConfig,
  values,
  rulesMap,
}: GetSPTableWithModelSchemaProps) => {

  const { moduleList, moduleTaskField, pageConfig, pageType, utils, metaInfoByRule, taskInfo } = metaConfig;

  const pageModuleConfig = pageConfig?.pageModuleConfig;
  const { myRoles } = useMetaStore();

  const spRecordListSchema = schemaList?.map((schemaRelation, i: number) => {
    const { parentCode, parentAttrCode } = schemaRelation;
    const resultModule = moduleList.find(
      (item) => item.handle === schemaRelation.code,
    );

    const {
      name: moduleName,
      handle: moduleHandle,
      namespaceHandle,
    } = resultModule;

    // 生成colums
    // let columns = resultModule?.fields;
    let columns = resultModule?.fields.map((field: Record<string, any>) => {
      const f = moduleTaskField[moduleHandle]?.find((item) => item.field_id === field.fieldID);
      const columsOption = {
        dataIndex: field.name,
        fieldID: field.fieldID,
        isRequired: !!f?.required,
      };
      if (f?.field_from === 'quote') {
        return {
          ...columsOption,
          isDisabled: true,
        };
      }
      return {
        ...columsOption,
      };
    });

    if (pageModuleConfig?.[moduleHandle]) {
      const moduleFieldsConfigList = pageModuleConfig[moduleHandle].configList;
      const existFieldIDs = moduleFieldsConfigList
        .filter((field: Record<string, any>) => (field.showSource))
        .map((field: Record<string, any>) => (field.fieldID));
      columns = columns?.filter((field: Record<string, any>) => (existFieldIDs.includes(field.fieldID)));
      // 排序
      columns?.sort((prevField: Record<string, any>, nextField: Record<string, any>) => {
        const prevFieldSort = moduleFieldsConfigList.findIndex((field: Record<string, any>) => {
          return field.fieldID === prevField.fieldID;
        });
        const nextFieldSort = moduleFieldsConfigList.findIndex((field: Record<string, any>) => {
          return field.fieldID === nextField.fieldID;
        });
        return prevFieldSort - nextFieldSort;
      });
    }

    // 获取上传模型映射
    const fileFieldMap = pageModuleConfig?.[moduleHandle]?.configList?.map((item) => {
      if (item?.relationName) {
        return { name: item.name, value: item.relationName };
      }
    }).filter((item) => item !== undefined) || [];

    // 基于规则生成的meta信息处理colums TODO行内不接
    // const ruleFields = metaInfoByRule?.[moduleHandle]?.fields || [];
    // ruleFields.forEach((ruleField: any) => {
    //   const column = columns.find((col: any) => col.dataIndex === ruleField.dataIndex);
    //   if (column) {
    //     Object.assign(column, ruleField);
    //   }
    // });

    // 每行的规则处理
    columns?.forEach((field) => {
      field.getRowConfig = (record: any) => {
        const res = ruleMapMatchExec(
          rulesMap,
          [moduleHandle, field.dataIndex].join('.'),
          getValuesByRow(moduleHandle, record, values, taskInfo?.relationTree),
          myRoles,
        );
        return res;
      };
    });


    return {
      componentName: 'Tabs.TabPane',
      sequence: pageModuleConfig?.[moduleHandle]?.sequence || 0,
      props: {
        tab: pageModuleConfig?.[moduleHandle]?.tabName || moduleName,
        key: `tab-item-${i}`,
        forceRender: true,
      },
      hidden: false,
      title: '',
      isLocked: false,
      condition: true,
      conditionGroup: '',
      handle: moduleHandle,
      children: [
        {
          componentName: 'SPtable',
          props: {
            API: { FetchAPI },
            title: '',
            search: false,
            copyable: false,
            options: false,
            rowCopyable: false,
            autoRowEditConfig: {
              hideSave: false,
            },
            headerTitle: 'none',
            moduleID: moduleHandle,
            namespaceID: namespaceHandle,
            assetModuleInfo: resultModule,
            columns,
            tableBaseMode: pageType,
            dataVersion: utils?.queryParams?.version || '0',
            fileConfig: {
              fileAutoSave: pageModuleConfig?.[moduleHandle]?.isFileModule && pageType === 'view',
              fileModule: pageModuleConfig?.[moduleHandle]?.isFileModule,
              mainModuleData: { [parentAttrCode]: values?.[parentCode]?.[parentAttrCode] || '' },
              fileFieldMap,
            },
          },
          hidden: false,
          title: '',
          isLocked: false,
          condition: true,
          conditionGroup: '',
        },
      ],
    };
  });

  return {
    spRecordListSchema: spRecordListSchema?.sort((pre, next) => pre.sequence - next.sequence),
  } as const;
};
